/* eslint-disable @next/next/no-html-link-for-pages */
import Link from 'next/link';
import Head from 'next/head';

const WebDienste = () => {
  return (
    <>
      <Head>
        <title>Corporate-Design - Webdienste</title>
      </Head>

      <h1>Webdienste</h1>
      <p className="lead">
        Die FHNW-Webdienste erlauben, Webinhalte der FHNW neben dem und in
        Ergänzung zum primären Webauftritt zu publizieren. Es handelt sich um
        Microsites.
      </p>
      <p>
        Die Verwendung von Webdiensten wird im entsprechenden Betriebskonzept
        geregelt. Webdienste unterliegen den Vorgaben aus dem CD-Manual der
        FHNW. Der vorliegende Styleguide definiert das Standard-Design für
        Webdienste gemäss CD-Manual und kann zur erleichterten Implementation
        desselben bei Eigenentwicklungen als Framework herangezogen werden.
      </p>
      <h2 className="mt-5">Vorgaben Standard-Design</h2>
      <p>
        Eigenentwicklungen von Webdiensten mit Standard-Design (vgl.
        Betriebskonzept, Kapitel 3f.) richten sich bezüglich Typographie,
        Webdienst-Header (inkl. Navigation), Webdienst-Footer und den übrigen
        UI-Elementen nach dem vorliegenden Styleguide, siehe entsprechende
        Basiselemente und Komponenten.
      </p>
      <h3>Pflichtelemente:</h3>
      <ul>
        <li>
          <a
            href={`${process.env.NEXT_PUBLIC_BASE_URL}/basic-elements/webdienst-header`}
            title="PAAS - Webdienst-Header"
          >
            Webdienst-Header
          </a>
        </li>
        <li>
          <Link
            href={'/basic-elements/webdienst-footer'}
            title="Webdienst Footer"
            legacyBehavior
          >
            <a>Webdienst-Footer</a>
          </Link>
        </li>
        <li>
          <Link
            href={'/basic-elements/cookie-hinweis'}
            title="Cookie Hinweis"
            legacyBehavior
          >
            <a>Cookie-Hinweis</a>
          </Link>
        </li>
      </ul>
      <p>
        <strong>Hinweis:</strong>{' '}
        <Link href={`/basic-elements/tools-header`} legacyBehavior>
          <a title="Tool-Header">Tools-Header</a>
        </Link>{' '}
        und{' '}
        <Link href={`/basic-elements/tools-footer`} legacyBehavior>
          <a title="Tool-Header">Tools-Footer</a>
        </Link>{' '}
        sind internen FHNW-Applikationen vorbehalten.
      </p>
      <h2>Vorgaben Custom-Design</h2>
      <p>
        Eigenentwicklungen von Webdiensten mit Custom-Design (vgl.
        Betriebskonzept, Kapitel 3f.) haben aus dem vorliegenden Styleguide nur
        Webdienst-Footer und Cookie-Hinweis zu integrieren, wobei die
        Typographie nicht aus dem Styleguide übernommen werden muss sondern frei
        wählbar ist. Die vollständige Wort-/Bildmarke ist zwingend und oben
        links zu platzieren, vgl. CD-Manual.
      </p>
      <h3>Vorgaben zum Custom-Design</h3>
      <ul>
        <li>
          <Link href="/basic-elements/webdienst-footer/" legacyBehavior>
            <a title="Webdienst-Footer">Webdienst-Footer</a>
          </Link>
        </li>
        <li>
          <Link href={'/basic-elements/cookie-hinweis'} legacyBehavior>
            <a title="Cookie Hinweis">Cookie-Hinweis</a>
          </Link>
        </li>
      </ul>
      <h2 className="mt-5">Kontakt</h2>
      <p>
        Bei Fragen zum Corporate Design der FHNW oder dem Betriebskonzept
        Webdienste kann die{' '}
        <a href="mailto:kommunikation@fhnw.ch">Kommunikation FHNW</a>{' '}
        kontaktiert werden. Technische Fragen bezogen auf die Implementation des
        vorliegenden Bootstrap-Frameworks können an{' '}
        <a href="mailto:webmaster@fhnw.ch">webmaster@fhnw.ch</a> gerichtet
        werden.
      </p>
    </>
  );
};

export default WebDienste;
